<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    福田站<br>
站点介绍<br>
福田站位于深圳市CBD中心区，深南大道与民田路交汇处，呈十字形布置。东侧为益田路，有市民中心，南侧为福华一路，有马克孛罗好日子五星酒店；西侧为鹏程一路，有广电及报业大厦；北侧为福中三路，有黄埔雅苑社区。车站为地下三层侧式车站，与2号线、11号线、广深港客运专线相连组成目前亚洲最大的地下综合交通枢纽。车站站厅采用中空设计，中部有一排能渗透下自然阳光的天窗，还有巨大的圆形自然采光的客服中心，阳光透过顶层玻璃能隐约在地上上到一个个倒立的“福”字，再加上车站吉祥物----“和平鸽”，象征着福田站追求和平、向往美好幸福的愿望，彰显出“福田站”的青春和活力。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:15	23:55	2号线	2分35秒	5分45秒<br>
莲塘	06:06	23:45	2号线	2分35秒	5分45秒<br>
福保	06:18	00:05	3号线	2分15-20秒	4分30秒<br>
双龙	06:26	23:08	3号线	2分15-20秒	4分30秒<br>
岗厦北	06:28	00:35	11号线	4分钟	6分32秒<br>
碧头	06:22	23:32	11号线	4分钟	6分32秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:19	23:54	2号线	4分钟	5分钟<br>
莲塘	06:06	23:45	2号线	4分钟	5分钟<br>
福保	06:25	00:04	3号线	3分15秒	5分钟<br>
双龙	06:26	23:08	3号线	3分15秒	5分钟<br>
岗厦北	06:28	00:35	11号线	4分34秒	6分钟<br>
碧头	06:22	23:32	11号线	4分34秒	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
赤湾	06:19	00:44	2号线	4分钟	5分钟<br>
莲塘	06:06	00:45	2号线	4分钟	5分钟<br>
福保	06:25	01:04	3号线	3分15秒	5分钟<br>
双龙	06:26	00:08	3号线	3分15秒	5分钟<br>
岗厦北	06:28	00:35	11号线	4分34秒	6分钟<br>
碧头	06:22	23:32	11号线	4分34秒	6分钟<br><br>
<br>
站点出口信息<br><br>
1号出入口:<br>
深南大道南侧(西)、兴业银行大厦、中心商务大厦、航天大厦、国际商会大厦、卓越大厦、新华保险大厦 、安信金融大厦<br><br>
2A/2B号出入口:<br>
深南大道罗湖方向、投资大厦公交站台<br><br>
3A/3B号出入口:<br>
深南大道南侧(东)、投资大厦、华融大厦、马哥孛罗好日子酒店、特美思大厦<br><br>
28号出入口:<br>
深南大道北侧(东)、太平金融大厦、基金大厦 、证券大厦、荣超中心、出租车场站<br><br>
29A/29B号出入口:<br>
深南大道南山方向、广电大厦公交站台<br><br>
31号出入口:<br>
深南大道北侧(西)、证券大厦、广电大厦、招商银行大厦、建设银行大厦<br>
公交换乘信息<br><br>
3a、3b、2a号口:<br>
公交站名： 投资大厦<br>
32,59,101,113,204,223,311,320,326,395,E18,K318,M363,M413,M414,M435, M447, M448 ,观光线1,机场1线,K204,N4,高峰专线15,高峰专线18,高峰专线38,高峰专线49,高峰专线62,高峰专线119<br><br>
12号口:<br>
公交站名： 福田高铁站<br>
E28,高峰专线62,M413,327,59,M221,E18<br><br>
14、15、16号口:<br>
公交站名： 市民广场西<br>
32路，101路，113路,204路,223路，K204路，N4路，高峰专线15，高峰专线18，高峰专线38，高峰专线49，101路快线<br><br>
29a、29b号:<br>
公交站名： 广电大厦<br>
32,59,101,113,204,223,311,320,326,395,M363,M413,M414,M435, M447, M448 ,观光线1,K204,N4,高峰专线15,高峰专线18,高峰专线38,高峰专线49,高峰专线62,高峰专线119<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "erhaoxian",
          title: "2号线",
          // icon: "chat",
          exact: true,
        },
        {
          name: "sanhaoxian",
          title: "3号线",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shiyihaoxian",
          title: "11号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>